import React from 'react'
import { Field, useFormikContext } from 'formik'
import { Grid } from '@mui/material'
import { FormDatePicker, CustomTextField } from 'src/form'

export type ParticipantAcceptedSchema = {
  programStartDate: string
  source: string
  programID?: string
}

const ParticipantAcceptedFields = () => {
  const { values } = useFormikContext<{ value: ParticipantAcceptedSchema }>()

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Field component={FormDatePicker} label="Program Start Date" name="value.programStartDate" fullWidth />
      </Grid>
      <Grid item xs={6}>
        <Field component={CustomTextField} label="Source" name="value.source" fullWidth />
      </Grid>
      {values.value.programID && (
        <Grid item xs={6}>
          <Field component={CustomTextField} label="Program ID" name="value.programID" fullWidth />
        </Grid>
      )}
    </Grid>
  )
}

export default ParticipantAcceptedFields
